<app-layout-row>
    <app-layout-column [width]="12">
        <div class="portalheadercaption">Onboarding Details</div>

        <div class="portalheadercontainer">
            <div>
                <p class="portalheadertext">Here you will see information received from the partner during the onboarding process</p>
                <p class="portalheadertext">
                    When the partner submits the information, it is possible to accept the individual sections and create the relevant data in the system.
                    <br>
                    Likewise, if the information is incorrect or incomplete, it is possible to reopen the individual sections for the partner to update the information.
                </p>
                <p class="portalheadertext">
                    You can, at any time during the onboarding process, communicate with the partner by using the Comments functionality
                </p>
            </div>
            <div class="portalheaderprogress">
                <p class="progressheader">Onboarding Progress</p>

                <div [class]="statusNumber() > 0 ? 'progressstep completed' : statusNumber() === 0 ? 'progressstep active' : 'progressstep pending'">
                    <i [class]="statusNumber() > 0 ? 'dx-icon-check' : 'dx-icon-arrowright'"></i>
                    <p>Onboarding setup</p>
                </div>

                <div [class]="statusNumber() > 1 ? 'progressstep completed' : statusNumber() === 1 ? 'progressstep active' : 'progressstep pending'">
                    <i [class]="statusNumber() > 1 ? 'dx-icon-check' : statusNumber() === 1 ? 'dx-icon-arrowright' : 'pending'"></i>
                    <p>The partner is providing onboarding information</p>
                </div>

                <div [class]="statusNumber() > 2 ? 'progressstep completed' : statusNumber() === 2 ? 'progressstep active' : 'progressstep pending'">
                    <i [class]="statusNumber() > 2 ? 'dx-icon-check' : statusNumber() === 2 ? 'dx-icon-arrowright' : 'pending'"></i>
                    <p>The information is being validated and accepted</p>
                </div>

                <div [class]="statusNumber() === 4 ? 'progressstep completed' : 'progressstep pending'">
                    <i [class]="statusNumber() === 4 ? 'dx-icon-check' : ''"></i>
                    <p>Onboarding completed</p>
                </div>
            </div>
        </div>
    </app-layout-column>
</app-layout-row>


<div class="status-box">
    @if (statusText()) {
        <i [class]="'status-icon ' + statusIconClass"></i>

        <p class="status-text">
            {{statusText()}}
        </p>

        @if (canMarkOnboardingAsDone()) {
            <app-link (onClick)="markOnboardingAsDone()">Click here to complete the onboarding</app-link>
        }
        @else if (canReopenOnboarding()) {
            <app-link (onClick)="reopenOnboarding()">Click here to reopen the onboarding</app-link>
        }
    }
</div>

@if (status() === 'Unknown') {
    <app-layout-row>
        <app-layout-column [width]="12">
            <app-button primary width="18rem" (buttonClick)="goToOnboardingSetup()">Setup New Onboarding</app-button>
        </app-layout-column>
    </app-layout-row>
}
@else {
    <app-layout-row margin="2rem">
        <app-layout-column [width]="12">
            <div class="groupcontainer">
                <app-partner-onboarding-information-group 
                    [title]="'Partner Information'"
                    [mainItemStatus]="model()?.Name.Status.Status" 
                    [createdEntities]=undefined 
                    [supportsAcceptance]="supportsAcceptance(model()?.Name.Status.Status)"
                    [supportsRemove]="false"
                    (acceptClicked)="acceptPartnerInformation(model().Name)"
                    (reopenClicked)="reopenPartnerInformation(model().Name)">
                    <app-partner-onboarding-information-item 
                        [item]="getPartnerNameItem(model()?.Name)"
                        [conversationData]="getConversationData(model()?.Name.ConversationId)">
                    </app-partner-onboarding-information-item>
                </app-partner-onboarding-information-group>
            </div>
        </app-layout-column>
    </app-layout-row>

    <app-layout-row margin="2rem">
        <app-layout-column [width]="12">
            <div class="groupcontainer">
                <app-partner-onboarding-information-group 
                    [title]="'Contact Information'"
                    [mainItemStatus]="model()?.Contact.Name.Status.Status" 
                    [createdEntities]="model()?.Contact.Name.Status.CreatedEntities" 
                    [supportsAcceptance]="supportsAcceptance(model()?.Contact.Name.Status.Status)"
                    [supportsRemove]="false"
                    (acceptClicked)="acceptContact(model().Contact)"
                    (reopenClicked)="reopenContact(model().Contact)"
                    (entityClicked)="goToContact()">
                    <app-partner-onboarding-information-item 
                        [item]="getPartnerContactNameItem(model()?.Contact)"
                        [conversationData]="getConversationData(model()?.Contact.Name.ConversationId)">
                    </app-partner-onboarding-information-item>
                    <app-partner-onboarding-information-item 
                        [item]="getPartnerContactEmailItem(model()?.Contact)"
                        [conversationData]="getConversationData(model()?.Contact.Email.ConversationId)">
                    </app-partner-onboarding-information-item>
                    <app-partner-onboarding-information-item 
                        [item]="getPartnerContactPhoneNumberItem(model()?.Contact)"
                        [conversationData]="getConversationData(model()?.Contact.PhoneNumber.ConversationId)">
                    </app-partner-onboarding-information-item>
                </app-partner-onboarding-information-group>
            </div>
        </app-layout-column>
    </app-layout-row>

    @if (model()?.Identifications.length > 0) {
        @for (identification of model()?.Identifications; track identification.IdentificationType.Id) {
            <app-layout-row margin="2rem">
                <app-layout-column [width]="12">
                    <div class="groupcontainer">
                        <app-partner-onboarding-information-group 
                            [title]="'Identification Type: ' + identification.IdentificationType.Name"
                            [mainItemStatus]="identification.Status.Status" 
                            [createdEntities]="identification.Status.CreatedEntities"
                            [supportsAcceptance]="supportsAcceptance(identification.Status.Status)"
                            [supportsRemove]="status()==='PartnerDone'"
                            (acceptClicked)="acceptIdentification(identification)"
                            (removeClicked)="removeIdentification(identification)"
                            (reopenClicked)="reopenIdentification(identification)"
                            (entityClicked)="goToIdentification()">
                            <app-partner-onboarding-information-item 
                                [item]="getIdentificationItem(identification)"
                                [conversationData]="getConversationData(identification.ConversationId)">
                            </app-partner-onboarding-information-item>
                        </app-partner-onboarding-information-group>
                    </div>
                </app-layout-column>
            </app-layout-row>
        }
    }

    @if (mergedDocumentTypesIn()?.length > 0) {
        <div class="sectionheader">Ingoing Document Types</div>
        @for (documentType of mergedDocumentTypesIn(); let idx = $index; track $index) {
            <app-layout-row margin="2rem">
                <app-layout-column [width]="12">
                    <div class="groupcontainer">
                        <app-partner-onboarding-information-group 
                            [title]="documentType.Name"
                            [mainItemStatus]="documentType.Status.Status" 
                            [createdEntities]="documentType.Status.CreatedEntities"
                            [supportsAcceptance]="supportsAcceptance(documentType.Status.Status)"
                            [supportsRemove]="status()==='PartnerDone'"
                            (acceptClicked)="acceptDocumentType(documentType, 'in')"
                            (removeClicked)="removeDocumentType(documentType, 'in')"
                            (reopenClicked)="reopenDocumentType(documentType)"
                            (entityClicked)="goToDistribution($event)">
                            <div class="group">
                                <app-partner-onboarding-information-item 
                                    [item]="getDocumentTypeItem(documentType)"
                                    [conversationData]="getConversationData(documentType.ConversationId)">  
                                </app-partner-onboarding-information-item>
                            </div>

                            @if (documentType.Transport) {
                                <div class="group">
                                    <p class="group-title">Transport: {{getTransportTypeDisplayName(documentType.Transport.Type)}}</p>

                                    @if (documentType.Transport.hasPartnerFilledTransportFields(DocumentDirection.Inbound)) {
                                        <div class="datafield-group">
                                            <app-group-box title="Connection details provided by partner" [required]="true" [isValid]="true" [disabled]="false" [supportsEdit]="false">
                                                @for (field of documentType.Transport.TransportFields ?? []; track field.Name) {
                                                    @if ((field.DocumentDirection === 'Inbound' || field.DocumentDirection === 'Both') && field.FilledBy === 'Partner') {
                                                        <app-partner-onboarding-information-item 
                                                            [item]="getTransportFieldItem(field, documentType.Transport)"
                                                            [conversationData]="getConversationData(field.ConversationId, '4rem', 'documentTypeIn-'+idx)">  
                                                        </app-partner-onboarding-information-item>
                                                    }
                                                }
                                            </app-group-box>
                                        </div>
                                    }

                                    @if (documentType.Transport.hasCustomerFilledTransportFields(DocumentDirection.Inbound)) {
                                        <div class="datafield-group">
                                            <app-group-box title="Connection details to be used by the partner" [required]="true" [isValid]="true" [disabled]="false" [supportsEdit]="false">
                                                @for (field of documentType.Transport.TransportFields ?? []; track field.Name) {
                                                    @if ((field.DocumentDirection === 'Inbound' || field.DocumentDirection === 'Both') && field.FilledBy === 'Customer') {
                                                        <app-partner-onboarding-information-item 
                                                            [item]="getTransportFieldItem(field, documentType.Transport)"
                                                            [conversationData]="getConversationData(field.ConversationId, '4rem', 'documentTypeIn-'+idx)">  
                                                        </app-partner-onboarding-information-item>
                                                    }
                                                }
                                            </app-group-box>
                                        </div>
                                    }
                                </div>
                            }
                            @else {
                                <div class="group">
                                    <p class="group-title">Transport</p>
                                    <p>No transport information has been provided for this document type</p>
                                </div>
                            }

                        </app-partner-onboarding-information-group>
                    </div>
                </app-layout-column>
            </app-layout-row>
        }
    }

    @if (mergedDocumentTypesOut()?.length > 0) {
        <div class="sectionheader">Outgoing Document Types</div>
        @for (documentType of mergedDocumentTypesOut(); let idx = $index; track $index) {
            <app-layout-row margin="2rem">
                <app-layout-column [width]="12">
                    <div class="groupcontainer">
                        <app-partner-onboarding-information-group 
                            [title]="documentType.Name"
                            [mainItemStatus]="documentType.Status.Status" 
                            [createdEntities]="documentType.Status.CreatedEntities"
                            [supportsAcceptance]="supportsAcceptance(documentType.Status.Status)"
                            [supportsRemove]="status()==='PartnerDone'"
                            (acceptClicked)="acceptDocumentType(documentType, 'out')"
                            (removeClicked)="removeDocumentType(documentType, 'out')"
                            (reopenClicked)="reopenDocumentType(documentType)"
                            (entityClicked)="goToDistribution($event)">
                            <div class="group">
                                <app-partner-onboarding-information-item 
                                    [item]="getDocumentTypeItem(documentType)"
                                    [conversationData]="getConversationData(documentType.ConversationId)">  
                                </app-partner-onboarding-information-item>
                            </div>

                            @if (documentType.Transport) {
                                <div class="group">
                                    <p class="group-title">Transport: {{getTransportTypeDisplayName(documentType.Transport.Type)}}</p>

                                    @if (documentType.Transport.hasPartnerFilledTransportFields(DocumentDirection.Outbound)) {
                                        <div class="datafield-group">
                                            <app-group-box title="Connection details provided by partner" [required]="true" [isValid]="true" [disabled]="false" [supportsEdit]="false">
                                                @for (field of documentType.Transport.TransportFields ?? []; track field.Name) {
                                                    @if ((field.DocumentDirection === 'Outbound' || field.DocumentDirection === 'Both') && field.FilledBy === 'Partner') {
                                                        <app-partner-onboarding-information-item 
                                                            [item]="getTransportFieldItem(field, documentType.Transport)"
                                                            [conversationData]="getConversationData(field.ConversationId, '4rem', 'documentTypeOut-'+idx)">  
                                                        </app-partner-onboarding-information-item>
                                                    }
                                                }
                                            </app-group-box>
                                        </div>
                                    }

                                    @if (documentType.Transport.hasCustomerFilledTransportFields(DocumentDirection.Outbound)) {
                                        <div class="datafield-group">
                                            <app-group-box title="Connection details to be used by the partner" [required]="true" [isValid]="true" [disabled]="false" [supportsEdit]="false">
                                                @for (field of documentType.Transport.TransportFields ?? []; track field.Name) {
                                                    @if ((field.DocumentDirection === 'Outbound' || field.DocumentDirection === 'Both') && field.FilledBy === 'Customer') {
                                                        <app-partner-onboarding-information-item 
                                                            [item]="getTransportFieldItem(field, documentType.Transport)"
                                                            [conversationData]="getConversationData(field.ConversationId, '4rem', 'documentTypeOut-'+idx)">  
                                                        </app-partner-onboarding-information-item>
                                                    }
                                                }
                                            </app-group-box>
                                        </div>
                                    }
                                </div>
                            }
                            @else {
                                <div class="group">
                                    <p class="group-title">Transport</p>
                                    <p>No transport information has been provided for this document type</p>
                                </div>
                            }
                        </app-partner-onboarding-information-group>
                    </div>
                </app-layout-column>
            </app-layout-row>
        }
    }
}